module.exports = __webpack_public_path__ + "img/pm.dc807bdc.svg";